import { useEffect, FC, useState } from "react";
// echarts and china maps
import { Divider, Form } from "antd";
import { Card } from "./components/Card";
import { getCityLearnView } from "@root/common/service";
import SubjectSelect from "@root/components/selectBox/subjectSelect";
const City: FC = () => {
  const [cardArray, setCardArray] = useState<any[]>([]);

  async function getCityViewData(subject?: number | undefined) {
    const {
      data: {
        instituteDataInfo,
        userDataInfo = { userCount: 0 },
        learnRecordInfo,
        learnCourseInfo,
      },
    } = await getCityLearnView({ subjectId: subject });
    const {
      countyHospitalCount,
      supportHospitalCount,
      recipientHospitalCount,
    } = instituteDataInfo;
    const { userCount } = userDataInfo;
    const { learnUserCount, learnRatio, watchTime, averageWatchTime } =
      learnRecordInfo;
    const {
      totalCourseCount,
      supportHospitalCourseCount,
      recipientHospitalCourseCount,
    } = learnCourseInfo;
    let initCardArray = [
      {
        name: "机构数量",
        subtitles: [
          {
            name: "机构总数",
            number: countyHospitalCount,
          },
          {
            name: "支援医院数量",
            number: supportHospitalCount,
          },
          {
            name: "受援医院数量",
            number: recipientHospitalCount,
          },
        ],
      },
      {
        name: "人数统计",
        subtitles: [
          {
            name: "注册总人数",
            number: userCount,
          },
          {
            name: "学习人数",
            number: learnUserCount,
          },
        ],
      },
      {
        name: "课程统计",
        subtitles: [
          {
            name: "课程总数",
            number: totalCourseCount,
          },
          {
            name: "支援医院课程数",
            number: supportHospitalCourseCount,
          },
          {
            name: "受援医院课程数",
            number: recipientHospitalCourseCount,
          },
        ],
      },
      {
        name: "学习统计",
        subtitles: [
          {
            name: "培训率",
            number: `${learnRatio}%`,
          },
          {
            name: "学习时长(小时)",
            number: watchTime,
          },
          {
            name: "平均学习时长(小时)",
            number: averageWatchTime,
          },
        ],
      },
    ];
    setCardArray([...initCardArray]);
  }
  useEffect(() => {
    getCityViewData();
  }, []);

  const onSelectChangeHandle = (value: any) => {
    if (value === "all") {
      value = undefined;
    }

    getCityViewData(value);
  };

  return (
    <div className="summarize">
      <div className="summarize-wrapper">
        <Form>
          <SubjectSelect
            label={false}
            showAll={true}
            styles={{ width: 160 }}
            onSelect={(value) => {
              onSelectChangeHandle(value);
            }}
          />
        </Form>
        <Divider />
        <div className="summarize-card-wrapper">
          {cardArray.map((item, index) => {
            return (
              <Card key={index} name={item.name} subtitle={item.subtitles} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default City;
